 /*
 Create By Sittikron : 30/05/2023
 Update By Sittikron : 09/08/2023  - เพิ่ม Permissionในการตรวจสอบ
 Update By Sittikron : 28/08/2023 - แก้ไขสิทธิทุกหน้า ที่เรียกการใช้  สิทธิ view  เปลี่ยนวิธีเขียนใหม่  ให้เหมือนหน้า m_project.js
 
 Update By POOM : 02/11/2023 - เพิ่มการ check service_list 
 Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
 Update By POOM : 2024-05-10  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

*/

import React, { useEffect, useState, Fragment } from "react";
import { Helmet } from "react-helmet";

import DepartmentView from "../PartialView/Department_View.js"
import DepartmentEdittableRow from "../PartialView/Department_EdittableRow.js"

import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { Class_ETC_MsgError, 
        Class_ETC_MsgErrorfocusByID, 
        Class_ETC_MsgSuccess, 
        Class_ETC_Warning, 
        Class_ETC_SessionTimeOut
      } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PaginationActions from "../PartialView/PaginationActions"

import { CP_CheckPermission } from "../Class/Class_Permission"

function M_department() {

  //#region ###################  Declare a variable   ###################

  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isCount, setIsCount] = useState(0);
  const [listDepartment, setListDepartment] = useState([]);
  const [editDepartmentId, setEditDepartmentId] = useState(null);
  const [isDepartmentStatus, setIsDepartmentStatus] = useState(true);
  const [editFormData, setEditFormData] = useState({
    Department_id: 0,
    Department_name: "",
    Department_status: 0,
    Department_desc: ""
  });

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);

  //#endregion

  //#region ###################  Paging               ###################

  const [page, setPage] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  //#endregion

  //#region ###################  open on loead        ###################

  useEffect(() => {
    if (isFirst === true) {
      GetConfig();
      if (isLoadedConfigData === true) {   
        let ckpermission = CP_CheckPermission("master" , ["department_view"] , false , true)
        if (ckpermission === true) {
          let ckservice_list = CP_CheckPermission("service_list" , ["department"] , false , true)
          if (ckservice_list === true)
          {
            setIsPermissionEdit(CP_CheckPermission("master" , ["department_edit"] , false , false))
            setIsPermissionDel(CP_CheckPermission("master" , ["department_delete"] , false , false))
            setIsPermissionAdd(CP_CheckPermission("master" , ["department_add"] , false , false))  
            BindList_Department("GET" ,function() {
              setIsFirst(false);
              setIsLoadProgress(false);
            });
          }
        }
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadedConfigData]);
 
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      document.getElementById("modal-New-Departments-close").click();
    }
  };

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  //#endregion

  //#region ###################  Bind Data            ###################

  async function BindList_Department(isAct , _callback) {
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      "dept_status": "-1"
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(configData.API_URL + "Department_Get", requestOptions)
      .then((response) => response.json())
      .then((result) => {

        if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else
        {
          if (result.total_Data > 0) {
            if (isAct === "DEL") {
              if (rowsPerPage * (page + 1) > result.total_Data) {
                let pagenow = Math.ceil(result.total_Data / rowsPerPage);
                setPage((pagenow === 0 ? 0 : pagenow - 1));
              }
            }
            else if (isAct === "GET") {
              setPage(0);
            }
            setListDepartment(result.data);
            setIsCount(result.total_Data);
            if (_callback != null) {
              _callback();
            }
          } else {
            setListDepartment([]);
            if (_callback != null) {
              _callback();
            }
          }
        }
      })
      .catch((error) => {
        setListDepartment([]);
        if (_callback != null) {
          _callback();
      }
      });
  }

  //#endregion

  //#region ###################  save add Data        ###################

  async function Clearvalueinmodel(){
    document.getElementById("txt_Department_Name").value = "";
    document.getElementById("txt_Department_Desc").value = "";
    setIsDepartmentStatus(true);
  }

  function Onclick_AddDepartment() {
    setIsLoadProgress(true);
    var istxtError = "";
    let isError = "";
    if (document.getElementById("txt_Department_Name").value.trim() === "") {
      istxtError = "txt_Department_Name";
    }
    if (istxtError !== "") {
      isError = "Empty";
    }
    if (isError !== "") {
      if (isError === "Empty") {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
      }
    }
    else {
      SaveDepartment();
    }
  };

  function SaveDepartment() {

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "dept_name": document.getElementById("txt_Department_Name").value.trim(),
      "dept_status": (isDepartmentStatus === true ? "1" : "0"),
      "dept_desc": document.getElementById("txt_Department_Desc").value.trim()
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Department_Add", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {
          
          document.getElementById("modal-New-Departments-close").click();
          document.getElementById("txt_Department_Name").value = "";
          document.getElementById("txt_Department_Desc").value = "";
          setIsDepartmentStatus(true);
          BindList_Department("",function() {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
          });


        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {

          
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);
          
        }
      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  }

   //#endregion

  //#region ###################  save edit Data       ###################
   
  function Onclick_EditDepartment(event, listDepartment) {
    event.preventDefault();
    setEditDepartmentId(listDepartment.dept_id);
    var statusTF = false;

    if (listDepartment.Department_status === 1) {
      statusTF = true;
    } else {
      statusTF = false;
    }
    const formValues = {
      Department_id: listDepartment.dept_id,
      Department_name: listDepartment.dept_name,
      Department_status: listDepartment.dept_status,
      Department_desc: listDepartment.dept_desc,
      Department_statusTF: statusTF,
    };

    setEditFormData(formValues);
  };

  function Onclick_SaveEditDepartment(status) {
    setIsLoadProgress(true);
    var istxtError = "";
    let isError = "";

    if (document.getElementById("txt_Department_Name_Edit").value.trim() === "") {
      istxtError = "txt_Department_Name_Edit";
    }

    if (istxtError !== "") {
      isError = "Empty";
    }

    if (isError !== "") {
      if (isError === "Empty") {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID(MsgDescription.ERR001, istxtError);
      }
    }
    else {
      SaveEditDepartment(status);
    }
  };

  function SaveEditDepartment(status) {

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "dept_id": document.getElementById("hd_idedit").value.trim(),
      "dept_name": document.getElementById("txt_Department_Name_Edit").value.trim(),
      "dept_status": (status === true ? "1" : "0"),
      "dept_desc": document.getElementById("txt_Department_Desc_Edit").value.trim()

    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Department_Edit", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {

          setEditDepartmentId(null);
          BindList_Department("",function() {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001, null);
          });
          

        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {

          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);

        }
      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  }

  function Onclick_CancelDepartment() {
    setEditDepartmentId(null);
  };

  //#endregion

  //#region ###################  delete Data          ###################

  function Onclick_DeleteDepartment(Department_id) {
    document.getElementById("hd_iddel").value = Department_id;
    Class_ETC_Warning(MsgDescription.CFM002, DelDepartment);
  };

  function DelDepartment() {

    setIsLoadProgress(true);

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);
    var raw = JSON.stringify({
      "dept_id": document.getElementById("hd_iddel").value
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Department_Del", requestOptions)

      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {

          BindList_Department("DEL",function() {
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          });

        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {
          
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);

        }
      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR003, null);
      });
  };

  //#endregion

  //#region ###################  Sorting Data          ###################

  function Onclick_SortingDepartment (Act, Department_id){

    setIsLoadProgress(true);

    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);
    var raw = JSON.stringify({
      "dept_id": Department_id.toString(),
      "act": Act.toString()
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(configData.API_URL + "Department_Sorting", requestOptions)

      .then(response => response.json())
      .then(result => {
        if (result.status_ID === 1) {

          BindList_Department("",function() {
            setIsLoadProgress(false);
          });

        }
        else if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else {
          
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.status_Desc, null);
          
        }
      })
      .catch(error => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });
  };

  //#endregion
 
  return (
    <>

     {isLoadProgress && (
        <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>Department list</title>
      </Helmet>

    {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
              <div className="row">
                <div className="col-md-10 offset-md-1">
                  <div className="container-fluid">
                    <h1 className="display-5"> <i className="fas fa-cubes" /> Department </h1>
                  </div>
                </div>
              </div>
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-10 offset-md-1">
                    {/* SELECT2 EXAMPLE */}
                    <div className="card  shadow">
                    <div className="card-header ">
                        <h3 className="card-title">
                          Result <small> ({isCount} items)</small>
                        </h3>
                        <div className="float-right">
                          <div className="btn-group">
                            {(isPermissionAdd === true) &&
                             <>
                                  <button
                                    title="Add New Departments" 
                                    className="btn btn-primary btn-sm"
                                    data-target="#modal-New-Departments" 
                                    data-toggle="modal"
                                    onClick={Clearvalueinmodel}
                                  >
                                    <i className="fa fa-plus" /> New Departments
                                  </button>
                             </>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="card-body p-0">
                          <TableContainer>
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table table-head-fixed text-nowrap table-hover"
                            border={0}
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell width={"5%"}  className="align-top"><b>#</b></TableCell>
                                <TableCell width={"30%"} className="align-top"><b>Department<span className="text-danger">*</span></b></TableCell>
                                <TableCell width={"30%"} className="align-top"><b>Description</b></TableCell>
                                <TableCell width={"10%"} className="align-top text-center"> <b>Status</b></TableCell>
                                <TableCell width={"15%"} className="align-top text-center"> <b>{isPermissionEdit === true ? "Sorting" : ""}</b></TableCell>
                                <TableCell width={"10%"} className="align-top"></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(listDepartment.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={6} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                                (listDepartment.length > 0 &&
                                  listDepartment
                                    .slice(
                                      page * rowsPerPage,
                                      page * rowsPerPage + rowsPerPage
                                    )
                                    .map((en) => (
                                      <Fragment key={en.rowindex}>
                                        {editDepartmentId === en.dept_id ? (
                                          <DepartmentEdittableRow
                                            listedit={editFormData}
                                            index={en.rowindex}
                                            Onclick_SaveEditDepartment={Onclick_SaveEditDepartment}
                                            Onclick_CancelDepartment={Onclick_CancelDepartment}
                                          />
                                        ) : (
                                          <DepartmentView
                                            list = {en}
                                            index = {en.rowindex}
                                            max = {listDepartment.length}
                                            Onclick_SortingDepartment={Onclick_SortingDepartment}
                                            Onclick_EditDepartment={Onclick_EditDepartment}
                                            Onclick_DeleteDepartment={Onclick_DeleteDepartment}    
                                            permissionEdit={isPermissionEdit}     
                                            permissionDel={isPermissionDel}                                   
                                          />
                                        )}

                                      </Fragment>
                                    )))}
                            </TableBody>
                            </Table>
                          </TableContainer>      
                          {listDepartment.length > 0 && (
                            <TablePagination
                              rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                              component="div"
                              count={listDepartment.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={PaginationActions}
                            />
                          )}                  
                      </div>
                      {/* /.card-body */}
                    </div>
                  

              {/* POPUP INSERT NEW CUSTOMERS */}

                <div className="modal fade" id="modal-New-Departments">
                  <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title">
                        <i className="nav-icon far fas fa-cubes" /> Department  
                        <span className="text-sm text-muted"> (Add new department) </span>
                      </h4>
                      <button 
                        type="button"
                        id="modal-New-Departments-close"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="form-horizontal">
                        <div className="form-group row">
                          <label className="text-sm col-sm-2 col-form-label">Name <span className="text-danger">*</span></label>
                          <div className="col-sm-10">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Name"
                                id="txt_Department_Name"
                              />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="text-sm col-sm-2 col-form-label">desc</label>
                          <div className="col-sm-10">
                             <textarea className="form-control" 
                                       rows={2} 
                                       placeholder="Description ..." 
                                       id="txt_Department_Desc"
                             />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="text-sm col-sm-2 col-form-label">Status </label>
                          <div className="col-sm-10">
                                <BootstrapSwitchButton
                                    onChange={(checked) => { setIsDepartmentStatus(checked) }}
                                    checked={isDepartmentStatus}
                                    width={ConfigETC.SwitchButton_in_active_width} 
                                    onlabel={ConfigETC.SwitchButton_active_text}
                                    onstyle={ConfigETC.SwitchButton_active_color}
                                    offlabel={ConfigETC.SwitchButton_inactive_text}
                                    offstyle={ConfigETC.SwitchButton_inactive_color}
                                    size="xs"
                                />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer justify-content-between">
                      <div>
                              {/* มีไว้สำหรับ CSS */}
                      </div>
                      <span className="float-right">
                        <button
                          title="Add New Departments"
                          type="button"
                          className="btn btn-primary"
                          onClick={() => Onclick_AddDepartment()}
                        >
                        <i className="fa  fa-save" /> Save
                      </button>
                     </span>
                    </div>
                  </div>
                  </div>
                </div> 

                {/* POPUP INSERT NEW CUSTOMERS */}
                         
                  </div>
                </div>
                {/* /.row (main row) */}
              </div>
              {/* /.container-fluid */}
            </section>
            {/* /.content */}
          </div>
          {/* /.content-wrapper */}
    </>
  );
}

export default M_department;
